import { Address } from './address';
import { BankDetails } from './bank-details';
import { Language } from './language';
import { Phone } from './phone';
import { Timezone } from './timezone';
import { UiGuideViewStatus } from '../api/ui-guide';
import { CreditCard } from './credit-card';

export interface User {
    firstName?: string;
    lastName?: string;
    email?: string;
    password?: string;
    phone?: Phone;
    addresses?: Address[];
    bankDetails?: BankDetails;
    banks?: BankDetails[];
    maximumAllowedUserBanks?: number;
    preferences?: UserPreferences;
    isEmailConfirmed?: boolean;
    isPhoneConfirmed?: boolean;
    hasWallet?: boolean;
    multisigBtcWalletEnabled?: boolean;
    verificationDetails?: UserVerificationDetails;
    creditCards?: CreditCard[];
    exchangeTermsAndConditionsAgreed?: boolean;
    uiGuideViewStatuses?: UiGuideViewStatus[];
    vip?: boolean;
    customerSupportContactDetails?: CustomerSupportContactDetails;
}

export interface UserPreferences {
    fiatCurrencyCode?: string;
    timeZone?: Timezone;
    language?: Language;
    totpFallbackDisabled: boolean;
}

export interface UserPreferencesInput {
    fiatCurrencyCode: string;
    timeZone: string;
    language: Language;
}
export interface UserVerificationDetails {
    tier: TierLevel;
    missingVerificationFields: TierLevel[];
}

export interface ConfirmIpAddressResponse {
    key: ConfirmIpAddressResponseKey;
    message: string;
}

export interface CustomerSupportContactDetails {
    name: string;
    email: string;
    phone: string;
    imageName: string;
}

export enum ConfirmIpAddressResponseKey {
    OK = 'OK',
    REQUEST_NEW_VALIDATION = 'REQUEST_NEW_VALIDATION',
    EXPIRED_TOKEN = 'EXPIRED_TOKEN',
    INVALID_TOKEN = 'INVALID_TOKEN',
    DIFFERENT_IP_ADDRESS = 'DIFFERENT_IP_ADDRESS',
    ALREADY_CONFIRMED = 'ALREADY_CONFIRMED'
}

export enum TierLevel {
    NONE = 'NONE',
    TIER_1 = 'TIER_1',
    TIER_2 = 'TIER_2',
    TIER_3 = 'TIER_3'
}
